<div class="dialog-container">
	<div class="header flex flex-align-center-center flex-gap" style="--gap: 5px">
		<h3 class="header-text">{{ data.headerTitle | uppercase }}</h3>
	</div>

	<div class="dialog-box-content">
		<div class="dialog-box-container dialog-box-text-container">
			<span class="dialog-box-text">To proceed, select the reason for manually setting</span>
			<span class="dialog-box-text">these transactions to {{ manualProcess }}</span>

			<mat-form-field
				appearance="outline"
				class="form-container"
				[ngClass]="{ clicked: optionOpen }"
				(click)="toggleOptionPanel($event, matSelectOption)"
				[attr.data-test]="'manual-process-dropdown'"
			>
				<mat-select
					#matSelectOption
					[(ngModel)]="selectedOption"
					name="manualProcessOption"
					[disableRipple]="true"
					[disableOptionCentering]="true"
					placeholder="Select an option"
					(openedChange)="isOptionOpen($event)"
					(selectionChange)="optionSelectionChange($event)"
				>
					<mat-option *ngFor="let option of manualProcessOption" [value]="option">
						{{ option.text }}
					</mat-option>
				</mat-select>
				<app-icon
					class="option-dropdown-arrow"
					[color]="'rgba(0, 0, 0, 0.54)'"
					[lineWidth]="'2.5'"
					[name]="'arrow-down'"
					[size]="'16'"
					[ngClass]="{ 'up-arrow': optionOpen }"
				></app-icon>
			</mat-form-field>

			<textarea
				*ngIf="showTextInput"
				class="text-area"
				placeholder="Type the reason (max 200)"
				maxlength="200"
				(input)="textInput($event)"
				[attr.data-test]="'text-input'"
			></textarea>
		</div>

		<mat-divider></mat-divider>

		<mat-dialog-actions class="dialog-buttons flex flex-row flex-align-end" mat-dialog-actions>
			<div>
				<button
					class="dialog-action-button"
					action-buttons
					mat-stroked-button
					(click)="cancel()"
					[attr.data-test]="'cancel-button'"
				>
					CANCEL
				</button>
				<button
					class="dialog-action-button"
					action-buttons
					color="dark"
					mat-flat-button
					(click)="confirm()"
					[disabled]="!enableContinue"
					[attr.data-test]="'mark-as-' + manualProcess.toLowerCase() + '-button'"
				>
					CONTINUE
				</button>
			</div>
		</mat-dialog-actions>
	</div>
</div>
